export default __webpack_public_path__ + "static/media/medaille-qdo-or-usage.b9d34849.png";